/**
 * @description Должен соответствовать projectName
 * @const
 */
export const UNIQUE_CONFIG_KEY = 'search-frontend';
